import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card flex-fill" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "text-info"
}
const _hoisted_6 = { class: "btn-toolbar" }
const _hoisted_7 = { class: "input-group input-group-sm me-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "btn-group btn-group-sm me-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "btn-group btn-group-sm" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "card-body d-flex flex-column flex-md-row"
}
const _hoisted_16 = { class: "text-center d-flex pe-4 justify-content-center" }
const _hoisted_17 = { class: "align-self-center" }
const _hoisted_18 = { class: "leader-image position-relative" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "d-flex justify-content-center small text-nowrap overflow-hidden mt-1 mb-2" }
const _hoisted_22 = { class: "lh-1" }
const _hoisted_23 = { class: "fw-bold mb-0" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = {
  key: 1,
  class: "card-body user-not-found-body d-flex flex-column align-items-center justify-content-center text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!
  const _component_carrer_summary_table = _resolveComponent("carrer-summary-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, [
      (_ctx.userNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-user-slash fa-fw me-2 text-danger" }, null, -1),
            _createTextVNode("Usuario no encontrado ", -1)
          ]))]))
        : (_ctx.leader?.usernamePK && !_ctx.searching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-clipboard-list me-2" }, null, -1),
              _createTextVNode("Plan de Carrera ", -1)
            ]))]))
          : (_ctx.searching)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "fas fa-cog fa-spin fa-fw me-1" }, null, -1),
                _createTextVNode("Buscando... ", -1)
              ]))]))
            : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Usuario / Correo",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchUsernameString) = $event)),
            disabled: _ctx.searching,
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args)), ["enter"]))
          }, null, 40, _hoisted_8), [
            [
              _vModelText,
              _ctx.searchUsernameString,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args))),
            title: "Buscar",
            disabled: _ctx.searchUsernameString == '' || _ctx.searching
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "fas fa-search" }, null, -1)
          ]))], 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: _ctx.searching || _ctx.leader == undefined,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refresh())),
            title: "Actualizar"
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fas fa-redo" }, null, -1)
          ]))], 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            disabled: 
              (_ctx.leader?.enroller == _ctx.loggedUserEnroller &&
                _ctx.leader?.usernamePK == _ctx.getUsernamePK) ||
              _ctx.leader == undefined
            ,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTeamLeader(_ctx.leader?.enroller))),
            title: "Subir un nivel"
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("i", { class: "fas fa-chevron-up" }, null, -1)
          ]))], 8, _hoisted_13),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeTeamLeader())),
            title: "Ir al mi equipo",
            disabled: _ctx.leader?.username == _ctx.getUsernamePK
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", { class: "fas fa-chevrons-up" }, null, -1)
          ]))], 8, _hoisted_14)
        ])
      ])
    ]),
    (_ctx.leader?.usernamePK && !_ctx.userNotFound && !_ctx.searching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("img", {
                  src: _ctx.leaderPicture,
                  alt: _ctx.leader.nickname,
                  class: _normalizeClass(["img-fluid rounded-circle d-block gtr-avatar-bg", _ctx.isVIP ? 'vip-stroke vip-shadow' : 'border border-1'])
                }, null, 10, _hoisted_19),
                (_ctx.leaderPackageId)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "position-absolute top-90 start-90 translate-middle badge rounded-pill leader-pkg-badge",
                      title: _ctx.leaderPackageLabel
                    }, [
                      _createVNode(_component_package_icon, {
                        product: _ctx.leaderPackageId,
                        colored: ""
                      }, null, 8, ["product"])
                    ], 8, _hoisted_20))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.leader.nickname), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.leader.username), 1)
                ])
              ])
            ])
          ]),
          (_ctx.leader?.usernamePK)
            ? (_openBlock(), _createBlock(_component_carrer_summary_table, {
                key: 0,
                "user-data": _ctx.leader
              }, null, 8, ["user-data"]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.userNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "fas fa-user-slash user-not-found-icon mb-2" }, null, -1),
            _createElementVNode("div", { class: "user-not-found-headline mb-2" }, " No encontramos a este usuario ", -1),
            _createElementVNode("div", { class: "small text-body-secondary" }, " Verifica que el nombre de usuario esté escrito correctamente e intenta de nuevo. ", -1)
          ]))]))
        : _createCommentVNode("", true)
  ]))
}